import * as Icons from './src/index.js';
export const Groups = {
    Dashboard: ['AboveAverage', 'BellowAverage'],
    Function: [
        'Add',
        'Delete',
        'Download',
        'Filters',
        'HamburgerExpand',
        'HamburgerTablet',
        'Minus',
        'Plus',
        'Sort',
        'Templates',
        'Trash',
    ],
    General: [
        'Client',
        'TeamMember',
        'ClientPreferences',
        'Copy',
        'DevNotes',
        'Document',
        'Edit',
        'Ellipsis',
        'EllipsisInCircle',
        'Eye',
        'GeneralWarning',
        'Group',
        'Group2',
        'Info',
        'Location',
        'Location1',
        'Notes1',
        'Paste',
        'Payment',
        'Phone',
        'Position',
        'Reply',
        'RoomType',
        'Search',
        'Time',
        'PendingSignup',
        'Video',
    ],
    Indicators: [
        'Checkmark',
        'Dedicated',
        'DefaultOutline',
        'ErrorDot',
        'ErrorLarge',
        'Error',
        'Locked',
        'Pause',
        'Recurring',
        'Star',
        'StepCheck',
        'StepcountNumber',
        'SuccessDot',
        'WarningDot',
        'Warning',
    ],
    Navigation: [
        'ArrowDown',
        'ArrowLeft',
        'ArrowRight',
        'ArrowUp',
        'BackArrow',
        'ChevronDoubleLeft',
        'ChevronDoubleRight',
        'ChevronDown',
        'ChevronLeftLarge',
        'ChevronLeft',
        'ChevronRightInCircle',
        'ChevronRight',
        'ChevronUp',
        'ChevronLeftInCircle',
        'CloseBold',
        'MouseIndicator',
        'CombinedChevronDefault',
        'CombinedChevronDown',
        'CombinedChevronUp',
    ],
    Shifts: [
        'ShiftsClient',
        'ShiftsDate',
        'ShiftsDeal',
        'ShiftsLocation',
        'ShiftsNotes',
        'ShiftsPrice',
        'ShiftsQuantity',
        'ShiftsTasks',
        'ShiftsTime',
        'ShiftsTrainingOutline',
        'ShiftsUnpaidBreak',
    ],
    SideNav: [
        'AgencyMembers',
        'Clients',
        'Communications',
        'Dashboard',
        'Explore',
        'Logout',
        'NewBooking',
        'Question',
        'Schedule',
        'Settings',
        'Shifts',
        'TeamMembers',
        'Timesheets',
    ],
    Avatars: ['Avatar', 'AvatarFill', 'MobileAvatarFill'],
};
export const BKJIconComponentMap = Object.entries(Icons).reduce((acc, [key, value]) => {
    return { ...acc, [key.replace('Icon', '')]: value };
}, {});
//# sourceMappingURL=BKJIcon.types.js.map